import styled, { css } from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, IconButton } from "@similarweb/ui-components";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";

export const StyledLabel = styled.label<{ isError: boolean; isDisabled: boolean; isLoading: boolean }>`
    background-color: ${colorsPalettes.bluegrey[100]};
    border: 1px dashed ${colorsPalettes.blue[400]};
    border-radius: 5px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    ${({ isError }) =>
        isError &&
        css`
            border-color: ${colorsPalettes.red["400_P"]};
        `};
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            border-color: ${colorsPalettes.carbon[100]};
            background-color: ${colorsPalettes.carbon[25]};
            cursor: not-allowed;
        `}
    ${({ isLoading }) =>
        isLoading &&
        css`
            pointer-events: none;
        `}
`;

export const StyledInput = styled.input`
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
`;

export const StyledRemoveIconButton = styled(IconButton)`
    &:hover {
        & ${SWReactIcons} {
            svg > path {
                fill: ${colorsPalettes.carbon[300]};
            }
        }
    }
    & ${SWReactIcons} {
        svg > path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;

export const StyledLoadingSpinner = styled(Spinner)<{ color?: string }>`
    display: inline-block;
    vertical-align: baseline;
    width: 8px;
    height: 8px;
    border-color: ${({ color }) => color};
    border-right-color: transparent;
`;

export const StyledLoadingTag = styled.div`
    background: ${colorsPalettes.carbon[0]};
    padding: 0 6px;
    height: 20px;
    border-radius: 19px;
    display: flex;
    align-items: center;
    border: 1px solid ${colorsPalettes.orange[300]};
    flex: 0 0 auto;
    gap: 4px;
`;

export const StyledToastButton = styled(Button)`
    & > div {
        color: ${colorsPalettes.carbon[0]} !important;
    }
`;
